import React from "react";

const ActiveUser = () =>{
  return(
    <div className="active--user">
      <section>
        <h5>3800+</h5>
        <p className="gn--color">ACTIVE <span className="lightblue--color">USER</span></p>
      </section>
      <section>
        <h5>230+</h5>
        <p className="gn--color">TRUSTED <span className="lightblue--color">BY COMPANY</span></p>
      </section>
      <section>
        <h5>$230M+</h5>
        <p className="gn--color">TRANS<span className="lightblue--color">ACTION</span></p>
      </section>
    </div>
  )
}

export default ActiveUser;